<template>
    <div class="select-dropdown">
  <a href="#"
    role="button"
    class="button is-primary"
    @click="toggle($event)"
  >
 {{buttonText}}
  </a>
  <transition name="slide-fade">
      <div class="select-dropdown-panel card arrow-box" v-show="panelOpen">
        <MultiSelectSelectList
          ref="selectList"
          :options="options"
          :selected="selected"
          @change="onChange($event)"
          @chosen="onChosen"
          >

      </MultiSelectSelectList>
      </div>
  </transition>
</div>
</template>

<script>

    import MultiSelectSelectList from "./MultiSelectSelectList";

    export default {
        name: "MultiSelectDropDown",
        components: {MultiSelectSelectList, },
        data() {
            return {
                panelOpen: true,
                buttonText: this.label + ' ' + this.placeholder
            }
        },
        props: ['options', 'selected', 'label', 'placeholder'],
        methods: {
            toggle() {
                this.panelOpen = !this.panelOpen;
            },
            onChange(event) {

                this.setButtonText(event.selected);
                this.$emit(event);
                console.log("CHANGE SUCCESSFUL", event)
            },
            setButtonText(selectedOptions) {

                if (selectedOptions.length === 0) {

                    this.buttonText = this.label + ' ' + this.placeholder;
                } else {
                    let text = this.placeholder.charAt(0).toUpperCase() + this.placeholder.slice(1) + ': ' + selectedOptions[0].label;

                    if (selectedOptions.length > 1) {
                        text += ' & ' + (selectedOptions.length - 1) + ' more'
                    }

                    this.buttonText = text;
                }
            },
            onChosen(chosen){
                this.$emit('chosen', chosen);
            }
        }
    }
</script>


<style scoped lang="scss">

    .button{
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 0.3rem;
        color: white;
        background-color: #008CBA;
        display: block;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .1s ease;
}

.slide-fade-enter, .slide-fade-leave-active {
    transform: translateY(20px);
    opacity: 0;
}

        .arrow-box:after,
        .arrow-box:before {
            bottom: 100%;
            left: 50%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            margin-bottom: 10px;
        }
        .arrow-box:after {
            border-color: rgba(255, 255, 255, 0);
            border-bottom-color: #fff;
            border-width: 7px;
            margin-left: -7px;
        }
        .arrow-box:before {
            border-color: rgba(234, 234, 234, 0);
            border-bottom-color: #cecece;
            border-width: 8px;
            margin-left: -8px;
        }




</style>
